import { cn } from "@/lib/utils";
import { GramLogoHorizontal } from "./variants/horizontal";
import { GramIcon } from "./variants/icon";
import { GramLogoVertical } from "./variants/vertical";

export const GramLogo = ({
  variant = "horizontal",
  className,
}: {
  variant?: "horizontal" | "vertical" | "icon";
  className?: string;
}): JSX.Element => {
  const variantsMap = {
    horizontal: GramLogoHorizontal,
    vertical: GramLogoVertical,
    icon: GramIcon,
  };
  return (
    <div
      role="img"
      aria-label="Speakeasy"
      className={cn("flex items-center dark:invert", className)}
    >
      {variantsMap[variant]()}
    </div>
  );
};
